import { GetDamagedCustomerImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImagesTabs/getDamagedCustomerImagesTabs.type';
import { getDamagedCustomerImagesTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImagesTabs/getDamagedCustomerImagesTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedCustomerImagesTabsOptions = (
  params: GetDamagedCustomerImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_CUSTOMER_DAMAGED_IMAGE_TABS', params],
    queryFn: () => getDamagedCustomerImagesTabsQueryFunction(params),
  });
};
